import { render } from "./PalletReceipt.vue?vue&type=template&id=44e56b0a"
import script from "./PalletReceipt.vue?vue&type=script&lang=js"
export * from "./PalletReceipt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__